export function formatCount(value: number): string {
  if (value >= 100000000) {
    return `${(value / 100000000).toFixed(1)}亿`;
  }
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)}万`;
  }
  return String(value);
}

export function formatDate(date: string): string {
  return date.replace(/-/g, "/");
}

export function formatRelative(date: string): string {
  const target = new Date(`${date}T00:00:00`).getTime();
  const now = new Date("2026-10-15T00:00:00").getTime();
  const days = Math.max(0, Math.round((now - target) / 86400000));
  if (days === 0) return "今天";
  if (days === 1) return "昨天";
  if (days < 30) return `${days} 天前`;
  if (days < 365) return `${Math.round(days / 30)} 个月前`;
  return `${Math.round(days / 365)} 年前`;
}